import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/footer-divider.svg'


const _hoisted_1 = { class: "footer-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "divider-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "footer-divider-image",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "copyright-container" }
const _hoisted_4 = { class: "small-text-grey-30 footer-text" }
const _hoisted_5 = { class: "small-text-grey-10 footer-text" }
const _hoisted_6 = { class: "small-text-grey-30 footer-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("footer.copyright")), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("footer.like-a-coffee")), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("footer.copyright-contact") + _ctx.email), 1)
    ])
  ]))
}